jQuery(document).ready(function($) {
    var modal = $("#modal__alert");
    var closeBtn = $("#modal__close");
    var acceptBtn = $("#acceptAlert");


    if ($("body").hasClass("page-id-1913")) {
        modal.fadeIn();
    }


    closeBtn.on("click", function() {
        modal.fadeOut();
    });

    acceptBtn.on("click", function() {
        modal.fadeOut();
    });


    $(window).on("click", function(event) {
        if ($(event.target).is(modal)) {
            modal.fadeOut();
        }
    });
});